import React from "react";
import { WizardMedication } from "@/types/medication";

interface DosageStepProps {
  medication: WizardMedication;
  onChange: (medication: WizardMedication) => void;
}

export const DosageStep = ({ medication, onChange }: DosageStepProps) => {
  return (
    <div className="space-y-6 animate-in fade-in slide-in-from-left">
      <div className="space-y-4">
        <label className="block">
          <span className="text-base font-medium">Dosage</span>
          <span className="text-sm font-small"> (required)</span>
          <input
            type="text"
            value={medication.dosage}
            onChange={(e) =>
              onChange({ ...medication, dosage: e.target.value })
            }
            className="mt-1 w-full rounded-lg border border-input bg-background px-4 py-3 text-foreground transition-smooth focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20"
            placeholder="e.g., 500mg"
            required
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
          />
        </label>
      </div>
    </div>
  );
};
